import { useResolveRoute } from '@mews/routing';
import { RouteName, ActionType, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { SmallContentContainer, SuspenseBoundary } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getEnterpriseName } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { useCommanderSelector } from '@mews-commander/utils';
import { BaseLayout } from '../../../components/layout';
import { Breadcrumbs } from '../../../components/BreadcrumbList';
import { PaymentsConfigurationForm } from '../components/forms/PaymentsConfigurationForm';
import { HeadingAction } from '../../../legacy/React/Components/HeadingAction/Action/types';

export const PaymentsConfiguration = () => {
    const resolveRoute = useResolveRoute();
    const enterpriseId = useCurrentEnterpriseId();

    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });
    const enterpriseName = useCommanderSelector((state) => getEnterpriseName(state, { enterpriseId }));

    const breadcrumbs: Breadcrumbs = [
        {
            text: enterpriseName,
            url: enterpriseUrl,
        },
        {
            text: lt('PaymentsConfigurationFormTitle'),
            active: true,
        },
    ];

    return (
        <BaseLayout actions={actions} breadcrumbs={breadcrumbs}>
            <SmallContentContainer>
                <SuspenseBoundary>
                    <PaymentsConfigurationForm />
                </SuspenseBoundary>
            </SmallContentContainer>
        </BaseLayout>
    );
};

const actions: HeadingAction[] = [
    {
        url: createGuideLink(ArticlePath.CardDataRetentionPolicy),
        target: '_blank',
        icon: IconName.Help,
        text: lt('Help'),
        type: ActionType.Link,
    },
];
